import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Typography, Grid } from '@mui/material';

import PageHeader from '../../../sharedModules/layout/PageHeader';
import LoadingWrapper from '../../../sharedModules/layout/LoadingWrapper';
import axios from '../../../sharedModules/utils/axios.utils';

interface InspectionReport {
  id: number;
  name?: string;
  technician?: string;
  date?: string;
  order_no?: string;
}

const InspectionReportShowPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [report, setReport] = useState<InspectionReport | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchReport = async () => {
      if (!id) return;
      setLoading(true);
      setError('');
      try {
        const response = await axios.get(`/home_services/inspection_reports/${id}`);
        setReport(response?.data);
      } catch (err: any) {
        setError(err?.response?.data?.error || err?.response?.data?.message || 'Failed to load report');
      } finally {
        setLoading(false);
      }
    };
    fetchReport();
  }, [id]);

  return (
    <LoadingWrapper isLoading={loading}>
      <Box sx={{ p: 3, maxWidth: 1200, margin: '0 auto' }}>
        <PageHeader
          mainTitle="Inspection Report"
          subTitle={report ? `${report.name || 'Report'} #${id}` : `#${id}`}
          backButtonLabel="Back to Reports"
          backButtonLink="/home_services/reports"
        />

        {error && (
          <Typography color="error" sx={{ mt: 2 }}>
            {error}
          </Typography>
        )}

        {report && !error && (
          <Grid container spacing={2} sx={{ mt: 2 }}>
            <Grid item xs={12} md={6}>
              <Typography variant="subtitle2" color="text.secondary">
                Name
              </Typography>
              <Typography variant="body1">{report.name || '—'}</Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="subtitle2" color="text.secondary">
                Technician
              </Typography>
              <Typography variant="body1">{report.technician || '—'}</Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="subtitle2" color="text.secondary">
                Date
              </Typography>
              <Typography variant="body1">{report.date || '—'}</Typography>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="subtitle2" color="text.secondary">
                Order Number
              </Typography>
              <Typography variant="body1">{report.order_no || '—'}</Typography>
            </Grid>
          </Grid>
        )}
      </Box>
    </LoadingWrapper>
  );
};

export default InspectionReportShowPage;
